export default __webpack_public_path__ + "static/media/NEOCRETE_LOGO_V2.9f061f28.webp";